import {
    STATUS_DRAFT,
    STATUS_OPEN,
    STATUS_PAID,
    STATUS_CANCELED,
    STATUS_PENDING_CONFIRMATION,
    DEFAULT_STATUS_STYLES as STATUS_STYLES, setFormChildGlobally, getBillingSettings
} from "../../../../services/SpaceBillingContants";
import datepicker from "vuejs-datepicker";
import FormErrorAlerts from "../../../../theme/molecules/FormErrorAlerts.vue";
import BillableBreadcrumb from "../../atoms/BillingBreadcrumb.vue";
import ContractItems from "../../../SpaceContracts/molecules/ContractItems.vue";
import WaitingIndicatorIcon from "../../../../theme/atoms/WaitingIndicatorIcon.vue";
import {datePickerLanguage} from "../../../../services/CalendarLocaleSQ";
import moment from "moment";
import InvoiceItems from "../../molecules/InvoiceItems.vue";
import ChildFormSelect from "../../../../theme/atoms/ChildFormSelect.vue";
import SettingSelect from "../../../../theme/atoms/SettingSelect.vue";
import {round} from "../../../../services/MathFunctions";
import EmailsSelect from "../../atoms/EmailsSelect.vue";
import SlideoutContent from "../../../../theme/molecules/SlideoutContent.vue";
import ConfirmDialog from "../../../../theme/organisms/ConfirmDialog.vue";

export const INVOICE_SUBMISSION_INDICATOR = 'INVOICE_SUBMISSION_INDICATOR'
export const INVOICE_CANCEL_INDICATOR = 'INVOICE_CANCEL_INDICATOR'
export const INVOICE_DELETE_INDICATOR = 'INVOICE_DELETE_INDICATOR'

export default {
    name: "InvoiceForm",
    props: {
        child: {
            type: Object,
            required: false
        },
        invoice: {
            type: Object,
            required: false
        }
    },
    computed: {
        dueDate() {
            return this.model.issue_date ? new Date(this.model.issue_date) : null
        },
        status() {
            return trans(`general.page.space_billing.status.${this.onFormStatus}`);
        },
        onFormStatus() {
            return this.model && this.model.status ? this.model.status : STATUS_DRAFT;
        },
        statusStyle() {
            return STATUS_STYLES[this.onFormStatus];
        },
        groupedTotals() {
            const totalsGrouped = {};

            for (const item of this.items) {
                if (item.currency_code === undefined) continue;

                if (totalsGrouped[item.currency_code] !== undefined) {
                    totalsGrouped[item.currency_code].total = totalsGrouped[item.currency_code].total + Number(item.price)
                    totalsGrouped[item.currency_code].tax = Number(totalsGrouped[item.currency_code].tax) + Number(this.calculateItemTax(item))
                    continue;
                }
                totalsGrouped[item.currency_code] = {
                    symbol: item.currency_symbol,
                    total: Number(item.price),
                    tax: this.calculateItemTax(item)
                }
            }

            return Object.values(totalsGrouped);
        },
        isManualSequence() {
            return this.sequence !== this.model.sequence;
        }
    },
    watch: {
        startDate: function (val) {
            this.model.start_date = val
        },
        child: function (val) {
            this.childModel = val;
        },
        childModel: function (val) {
            if (!val || !val.parents) return;
            const to = val.parents.map(v => {
                return {text: v.email}
            });
            setFormChildGlobally(val)
            this.emails = {to, cc: [], bcc: [],}
        },
        taxRate: {
            handler(val) {
                this.taxRateData = val[0]?.data;
            },
            deep: true
        }
    },
    components: {
        ConfirmDialog,
        SlideoutContent,
        InvoiceItems,
        datepicker,
        FormErrorAlerts,
        BillableBreadcrumb,
        ContractItems,
        WaitingIndicatorIcon,
        ChildFormSelect,
        SettingSelect,
        EmailsSelect
    },
    data() {
        return {
            STATUS_DRAFT,
            STATUS_OPEN,
            STATUS_PAID,
            STATUS_CANCELED,
            STATUS_PENDING_CONFIRMATION,
            STATUS_STYLES,
            INVOICE_SUBMISSION_INDICATOR,
            INVOICE_CANCEL_INDICATOR,
            INVOICE_DELETE_INDICATOR,
            errors: [],
            childModel: null,
            showNoteInfo: false,
            openOnSave: false,
            model: {
                sequence: '',
                start_date: null,
                status: STATUS_DRAFT,
                auto_send: true
            },
            showSequenceConflictPopup: false,
            totals: [],
            items: [],
            startDate: null,
            files: [],
            taxRate: [],
            taxRateData: null,
            emails: {
                to: [],
                cc: [],
                bcc: [],
            },
            ccBcc: false,
            sequence: null,
            note: null,
        }
    },
    methods: {
        language: datePickerLanguage,
        round: round,
        calculateItemTax(item) {
            if (!this.taxRateData) return 0;

            const itemPrice = item.price * item.quantity;
            const itemTax = (itemPrice / (100 / Number(this.taxRateData.value) + 1));

            return round(itemTax, 2).toFixed(2);
        },
        async init() {
            this.childModel = this.child;

            if (this.invoice) {
                this.loadInvoice()
            } else {
                this.setSequence();
                const {invoice_info} = await getBillingSettings();
                this.note = this.model.note = invoice_info ? invoice_info[0].value : null;
            }

        },
        async submit(event) {
            event.preventDefault();
            this.errors = [];
            this.$wait.start(INVOICE_SUBMISSION_INDICATOR);

            const form = await this.parseForm(event.target)

            axios.post(this.getSubmitURL(), form, {headers: {'content-type': 'multipart/form-data'}})
                .then(response => {
                    this.handleCreate(response.data.data)
                })
                .catch((error) => {
                    if (error.response.status === 409) {
                        this.handleInvoiceSequenceConflict(error.response.data.data)
                        this.$wait.end(INVOICE_SUBMISSION_INDICATOR);
                        return;
                    }
                    this.openOnSave = false;
                    if (error.response.data.message === '' && error.response.data.errors) {
                        let errors = Object.values(error.response.data.errors);
                        this.errors = errors.map(val => val[0] || 0)
                    } else {
                        this.$notify({type: 'error', text: error.response.data.message});
                    }
                    this.$wait.end(INVOICE_SUBMISSION_INDICATOR);
                });
        },
        handleCreate(data) {
            this.files = [];
            this.openOnSave = false;
            this.$wait.end(INVOICE_SUBMISSION_INDICATOR);
            this.$emit('invoice-saved', data);
            this.loadInvoice(data.id);
            this.openOnSave = false;
        },
        saveAndActivate() {
            this.openOnSave = true;
            this.$refs.submitBtn.click();
        },
        closePanel(data) {
            this.$emit('closePanel', {child: this.childModel});
        },
        async setSequence() {
            const result = await axios.get(`/space/billing/invoices/sequence`);
            this.sequence = this.model.sequence = result.data.data
        },
        handleItemsChange(items) {
            this.items = null;
            this.items = items;
        },
        loadInvoice(invoiceId) {
            axios.get(`/space/billing/invoices/read/${(invoiceId ?? this.invoice.id)}`, {
                params: {
                    include: 'items.product;child.parents;tax',
                    with_count: 'documents'
                }
            }).then((result) => {
                this.model = result.data.data;
                this.startDate = new Date(this.model.start_date);
                if ( this.model.tax) {
                    this.taxRate = [
                        {
                            data: this.model.tax,
                            label: this.model.tax.label,
                            id: this.model.tax.id
                        }
                    ];
                }

                this.childModel =  result.data.data.child;
                this.items = this.model.items.map(v => {
                    v.price = v.price / 100;
                    return v
                })
            });
        },
        getSubmitURL() {
            const createUrl = `/space/billing/invoices/${this.openOnSave ? 'save-open' : 'new'}`;
            const updateUrl = `/space/billing/invoices/${this.model.id}${this.openOnSave ? `/save-open` : ''}`;

            return this.model.id ? updateUrl : createUrl;
        },
        async parseForm(data) {
            if (!this.isManualSequence && !this.model.id) {
                await this.setSequence()
            }

            const form = new FormData(data);

            if (this.childModel?.id) {
                form.append('child_id', this.childModel?.id);
            }
            form.append('issue_date', this.model.issue_date ? moment(this.model.issue_date).format('YYYY-MM-DD') : this.model.issue_date);

            if (this.model.due_date) {
                form.append('due_date', moment(this.model.due_date).format('YYYY-MM-DD'));
            }

            form.append('auto_send', this.model.auto_send ? '1' : '0');
            form.append('email_to', this.emails?.to.map(v => v.text).join(','));
            form.append('email_cc', this.emails?.cc?.map(v => v.text).join(','));
            form.append('email_bcc', this.emails?.bcc?.map(v => v.text).join(','));

            if (this.taxRateData) {
                form.append('tax_rate_id', this.taxRateData.id);
            }

            this.files.forEach(file => {
                form.append('files_names[]', file.name)
                form.append('files[]', file)
            });

            this.items.forEach((item, index) => {
                Object.keys(item).forEach(key => {
                    if (!this.model.id && ['id', 'space_invoice_id'].includes(key)) {
                        return
                    }
                    form.append(`items[${index}][${key}]`, (key === 'price') ? item[key] * 100 : item[key])
                })
            });

            return form;
        },
        cancelInvoice() {
            axios.post(`/space/billing/invoices/${this.model.id}/cancel`)
                .then(response => {
                    this.$wait.end(INVOICE_CANCEL_INDICATOR);
                    this.loadInvoice(response.data.data.id);
                })
                .catch((error) => {
                    this.$wait.end(INVOICE_CANCEL_INDICATOR);
                    this.$notify({type: 'error', text: error.response.data.message});
                });

        },
        deleteInvoice() {
            axios.delete(`/space/billing/invoices/${this.model.id}`)
                .then(response => {
                    this.$wait.end(INVOICE_DELETE_INDICATOR);
                    this.closePanel();
                })
                .catch((error) => {
                    this.$wait.end(INVOICE_DELETE_INDICATOR);
                    this.$notify({type: 'error', text: error.response.data.message});
                });
        },
        renewInvoice() {
            delete this.model.id;
            this.model.status = STATUS_DRAFT;
            this.setSequence().then((sequence) => this.$refs.submitBtn.click());
        },
        selectedFiles(event) {
            for (let file of event.target.files) {
                this.files.push(file)
            }
        },
        openDocumentsPanel(activeTab) {
            const panel = this.$showPanel({
                component: 'invoice-documentation-panel',
                openOn: 'right',
                width: 576,
                disableBgClick: false,
                cssClass: 'sidePanel',
                props: {
                    invoiceId: this.model.id,
                    activeTab: activeTab ?? 'tabInvoices'
                }
            });
            panel.promise.then(result => {
                this.loadInvoice(this.model.id)
            });
        },
        openPayInvoicePanel() {
            const panel = this.$showPanel({
                component: 'payment-form',
                openOn: 'right',
                width: 576,
                disableBgClick: true,
                cssClass: 'sidePanel',
                props: {
                    invoice: this.model,
                }
            });
            panel.promise.then(result => {
                this.loadInvoice(this.model.id)
            });
        },
        uploadDocuments() {
            this.$wait.start(INVOICE_SUBMISSION_INDICATOR);
            const form = new FormData();
            this.files.forEach(file => {
                form.append('files_names[]', file.name)
                form.append('files[]', file)
            });
            axios.post(`/space/billing/invoices/${this.model.id}/upload-documents`, form, {headers: {'content-type': 'multipart/form-data'}})
                .then(response => {
                    this.handleCreate(response.data.data)
                })
                .catch((error) => {
                    this.openOnSave = false;
                    if (error.response.data.data) {
                        this.handleCreate(error.response.data.data)
                    }
                    if (error.response.data.message === '' && error.response.data.errors) {
                        let errors = Object.values(error.response.data.errors);
                        this.errors = errors.map(val => val[0] || 0)
                    } else {
                        this.$notify({type: 'error', text: error.response.data.message});
                    }
                    this.$wait.end(INVOICE_SUBMISSION_INDICATOR);
                });
        },
        async handleInvoiceSequenceConflict(data) {
            await this.setSequence()
            this.$refs.conflictConfirmDialog.show(
                'Invoice with the sequence number already exists!',
                'We generated a new invoice sequence. Do you want to save the invoice with the new sequence?')
        }
    },
    mounted() {
        this.init()
    }
}
